import { render } from "./Withdrawal.vue?vue&type=template&id=ca1b5616&scoped=true"
import script from "./Withdrawal.vue?vue&type=script&lang=js"
export * from "./Withdrawal.vue?vue&type=script&lang=js"

import "./Withdrawal.vue?vue&type=style&index=0&id=ca1b5616&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1b5616"]])

export default __exports__